import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { EmployeeService } from 'src/app/services/core/services/employee/employee.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.css']
})
export class AddEmployeeComponent implements OnInit {
  employeeForm!: FormGroup
  submitted = false;
  employeeId: any;
  user: any;
  companies:any;
  selectedCompany:any = '';
  syncToken:any;
  quickBookId:any;

  constructor(
    private companyService: CompanyService,
    private sharedDataService: SharedDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private employeeService: EmployeeService) { }

  ngOnInit(): void {
    this.buildForm();
    this.getCompanies();
    this.getUser();

    this.activatedRoute.params
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        this.employeeId = params['id'];
        if (this.employeeId) {
          this.getEmployeeById();
        }
    });
  }

  buildForm() {
    this.employeeForm = this.fb.group({
      // Company: ['', Validators.required],
      GivenName: ['', Validators.required],
      FamilyName: ['', [Validators.required]],
      PrimaryAddr: this.fb.group({
        CountrySubDivisionCode: ['', Validators.required],
        City: ['', Validators.required],
        PostalCode: ['', Validators.required],
        // Id: [''],
        Line1: ['', Validators.required],
      }),
      PrimaryPhone: this.fb.group({
        FreeFormNumber: ['', Validators.required],
      }),
      SSN: ['',  [Validators.required,Validators.pattern(/^[0-9Xx]{3}-[0-9Xx]{2}-[0-9Xx]{4}$/)]],

      reference  : this.fb.group({
        name: [''],
        id: [''],
      })
      // CustomField: this.fb.array([
      // this.fb.group({
      //   DefinitionId: [''],
      //   Name: [''],
      // }),]),
    });
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user) {
          // this.employeeForm.patchValue({
          //   company: this.user.id
          // })
        }
      }
    })
  }

  get form() {
    return this.employeeForm.controls;
  }

  get primaryAddr() {
    return this.employeeForm.get('PrimaryAddr') as FormGroup;
  }

  get primaryPhone() {
    return this.employeeForm.get('PrimaryPhone') as FormGroup;
  }

  get reference(): FormGroup {
  return this.employeeForm.get('reference') as FormGroup;
}

  onSave() {
    this.submitted = true;
    if (this.employeeForm.invalid) {
      return;
    }
     const payload = {
      ...this.employeeForm.value,
      company: this.selectedCompany
    };

    if(this.employeeId){
      payload.SyncToken = this.syncToken,
      payload.Id = this.quickBookId
    }

    this.employeeService.saveEmployee(this.employeeId, payload).pipe(untilDestroyed(this)).subscribe(
        {
        next: (data: any) => {
          if (data) {
           this.router.navigateByUrl('/employee')
          }
        },
        error: (err) => {
           sweetAlert("Error", err, "error", "OK");
        },
        complete: () => {
        }
      }
    )
  }


  getCompanies() {
    
    this.companyService.getCompanies({status:'created'}).subscribe((data:any) => {
      if (data) {
        this.companies = data.results
      }
    })
  }

  getEmployeeById() {
    this.employeeService.getEmployeeById(this.employeeId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.employeeForm.patchValue({
          ...data
        })
         this.selectedCompany = data.company;
         this.syncToken = data.SyncToken
         this.quickBookId = data.Id
      }
    })
  }

   onSelectAddress(place: any): void {
    
    const selectedAddress = place.address_components;
    // city
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';

    // state
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.short_name : '';

      // Postal Code
  const postalCode = selectedAddress.find((data: any) =>
    data.types.includes('postal_code')
  );
  const postalCodeValue = postalCode ? postalCode.long_name : '';

  // Country
  const country = selectedAddress.find((data: any) =>
    data.types.includes('country')
  );
  const countryName = country ? country.long_name : ''; 

    this.employeeForm.patchValue({
      PrimaryAddr: {
        Line1: place.formatted_address,
        CountrySubDivisionCode: stateName,
        City: cityName,
        PostalCode:postalCodeValue,
      }
    });


  }

}
